import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Cookies from "js-cookie";

import { AiFillStar, AiOutlineHome } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { LuListTodo } from "react-icons/lu";
import { IoLogOutOutline } from "react-icons/io5";
import { PiExamLight } from "react-icons/pi";
import { MdOutlineFileUpload } from "react-icons/md";
import { BiRevision } from "react-icons/bi";
import { PiGraph } from "react-icons/pi";

function NavBar(props) {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/"
                onClick={() => {
                  updateExpanded(false);
                  props.setLearning(false);
                }}
              >
                <AiOutlineHome style={{ marginBottom: "7px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning"
                onClick={() => updateExpanded(false)}
              >
                <MdOutlineFileUpload style={{ marginBottom: "7px" }} /> Upload
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning/day-to-day"
                onClick={() => updateExpanded(false)}
              >
                <FaSearch style={{ marginBottom: "7px" }} /> Search
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning/todo"
                onClick={() => updateExpanded(false)}
              >
                <LuListTodo style={{ marginBottom: "7px" }} /> To-Do
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning/graph"
                onClick={() => updateExpanded(false)}
              >
                <PiGraph style={{ marginBottom: "2px" }} /> K Graph
              </Nav.Link>
            </Nav.Item>

            {/* <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning/this-month"
                onClick={() => updateExpanded(false)}
              >
                <BsCalendar2Month style={{ marginBottom: "2px" }} /> Month
              </Nav.Link>
            </Nav.Item> */}

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning/revision"
                onClick={() => updateExpanded(false)}
              >
                <BiRevision style={{ marginBottom: "2px" }} /> Revise
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/learning/test"
                onClick={() => updateExpanded(false)}
              >
                <PiExamLight style={{ marginBottom: "2px" }} /> Test
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="fork-btn">
              <Button
                as={Link}
                to="/"
                className="fork-btn-inner"
                onClick={() => {
                  // localStorage.removeItem("user_token");
                  Cookies.remove("user_token");
                  props.setIsAuthenticated(false);
                  props.setLearning(false);
                }}
              >
                <IoLogOutOutline style={{ fontSize: "1.2em" }} />{" "}
                <AiFillStar style={{ fontSize: "1.1em" }} />
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
